/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { TaskInstanceView } from './TaskInstanceView';
import {
    TaskInstanceViewFromJSON,
    TaskInstanceViewFromJSONTyped,
    TaskInstanceViewToJSON,
    instanceOfTaskInstanceView,
} from './TaskInstanceView';

/**
 * 
 * @export
 * @interface GetTaskResponseContent
 */
export interface GetTaskResponseContent {
    /**
     * 
     * @type {TaskInstanceView}
     * @memberof GetTaskResponseContent
     */
    task: TaskInstanceView;
}


/**
 * Check if a given object implements the GetTaskResponseContent interface.
 */
export function instanceOfGetTaskResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "task" in value;
    return isInstance;
}

export function GetTaskResponseContentFromJSON(json: any): GetTaskResponseContent {
    return GetTaskResponseContentFromJSONTyped(json, false);
}

export function GetTaskResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTaskResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'task': TaskInstanceViewFromJSON(json['task']),
    };
}

export function GetTaskResponseContentToJSON(value?: GetTaskResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'task': TaskInstanceViewToJSON(value.task),
    };
}

